import PropTypes from "prop-types";
import React from "react";
import { Button } from "react-bootstrap";

export default class DatePickerCalendar extends React.Component
{
	constructor(props)
	{
		super(props);

		this.handleClick = this.handleClick.bind(this);
		this.handleClickPreviousMonth = this.handleClickPreviousMonth.bind(this);
		this.handleClickNextMonth = this.handleClickNextMonth.bind(this);
		this.handleClickToday = this.handleClickToday.bind(this);
	}

	handleClick(day)
	{
		const date = this.props.displayDate;
		var newSelectedDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), day, 0, 0, 0, 0));
		this.props.onChangeSelectedDate(newSelectedDate);
	}

	handleClickPreviousMonth()
	{
		var newDisplayDate = new Date(this.props.displayDate);
		newDisplayDate.setUTCMonth(newDisplayDate.getUTCMonth() - 1);
		this.props.onChangeMonth(newDisplayDate);
	}

	handleClickNextMonth()
	{
		var newDisplayDate = new Date(this.props.displayDate);
		newDisplayDate.setUTCMonth(newDisplayDate.getUTCMonth() + 1);
		this.props.onChangeMonth(newDisplayDate);
	}

	handleClickToday()
	{
		this.handleClick(new Date().getUTCDate());
	}

	render()
	{
		var currentDate = new Date();
		var currentDay = currentDate.getUTCDate();
		var currentMonth = currentDate.getUTCMonth();
		var currentYear = currentDate.getUTCFullYear();
		var selectedDay = this.props.selectedDate ? this.props.selectedDate.getUTCDate() : null;
		var selectedMonth = this.props.selectedDate ? this.props.selectedDate.getUTCMonth() : null;
		var selectedYear = this.props.selectedDate ? this.props.selectedDate.getUTCFullYear() : null;
		var year = this.props.displayDate.getUTCFullYear();
		var month = this.props.displayDate.getUTCMonth();
		var firstDay = new Date(Date.UTC(year, month, 1));
		var startingDay = this.props.weekStartsOnMonday ? (firstDay.getUTCDay() === 0 ? 6 : firstDay.getUTCDay() - 1) : firstDay.getUTCDay();

		var monthLength = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();

		var weeks = [];
		var day = 1;

		for (var i = 0; i < 9; i++)
		{
			var week = [];
			for (var j = 0; j <= 6; j++)
			{
				if (day <= monthLength && (i > 0 || j >= startingDay))
				{
					var selected = day === selectedDay && month == selectedMonth && year === selectedYear;
					var current = day === currentDay && month == currentMonth && year === currentYear;
					week.push(
						<div
							key={i + "_" + j}
							onClick={this.handleClick.bind(this, day)}
							style={{cursor: "pointer", padding: this.props.cellPadding}}
							className={"calendarCell " + (selected ? "bg-primary" : current ? "text-muted" : "")}>
							{day}
						</div>);
					day++;
				}
				else
				{
					week.push(<div className="calendarCell" key={i + "_" + j} />);
				}
			}
			weeks.push(<div className="calendarRow" key={"week_" + i}>{week}</div>);
			if (day > monthLength) {
				break;
			}
		}

		return (
			<div
				className={"popover " + this.props.calendarPlacement}
				style={{display: "block", top: "30px", left: "0px"}}
				onClick={this.props.preventClose}
			>
				<div className="arrow"/>
				<div className="popover-content" >
					<div className="text-center calendarHeader" onKeyDown={this.props.onKeyDown}>
						<div
							className="text-muted pull-left"
							onClick={this.handleClickPreviousMonth}
							style={{cursor: "pointer"}}
						>
							{this.props.previousButtonElement}
						</div>
						<span>
							{this.props.monthLabels[this.props.displayDate.getUTCMonth()]} {this.props.displayDate.getUTCFullYear()}
						</span>
						<div
							className="text-muted pull-right"
							onClick={this.handleClickNextMonth}
							style={{cursor: "pointer"}}
						>
							{this.props.nextButtonElement}
						</div>
						<hr />
					</div>
					<div className="text-center calendarBody">
						<div className="calendarRow">
							{this.props.dayLabels.map((label, index)=>{
								return(
									<div key={label + index}
										className="text-muted calendarCell"
										style={{padding: this.props.cellPadding}}>
										<small>{label}</small>
									</div>
								);
							})}
						</div>
						{weeks}

						{this.props.showTodayButton &&
							<div className="calendarRow" style={{ paddingTop: "9px" }}>
								<Button
									block
									bsSize="xsmall"
									className="u-today-button"
									onClick={this.handleClickToday}
								>
									{this.props.todayButtonLabel}
								</Button>
							</div>
						}
					</div>
				</div>
			</div>
		);
	}
}

DatePickerCalendar.defaultProps = {
	dayLabels: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	displayDate: new Date,
	previousButtonElement: "<",
	monthLabels: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	nextButtonElement: ">",
	showTodayButton: true,
	todayButtonLabel: "Today"
};

DatePickerCalendar.propTypes = {
	displayDate: PropTypes.object,
	selectedDate: PropTypes.object,
	todayButtonLabel: PropTypes.string,
	cellPadding: PropTypes.string,
	weekStartsOnMonday: PropTypes.bool,
	showTodayButton: PropTypes.bool,
	dayLabels: PropTypes.arrayOf(PropTypes.string),
	monthLabels: PropTypes.arrayOf(PropTypes.string),
	onChangeSelectedDate: PropTypes.func,
	onChangeMonth: PropTypes.func,
	onKeyDown: PropTypes.func,
	preventClose: PropTypes.func,
	calendarPlacement: PropTypes.oneOf(["top", "right", "bottom", "left"]),
	previousButtonElement: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
	nextButtonElement: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
};



// WEBPACK FOOTER //
// ./Components/utils/DatePickerCalendar.jsx